// src/config/arenaLeagues.js

// Daily + quarterly rewards tuned against your shop economy:
//
//   Soul packs (shop):
//     100 SD  for  100 coins
//     575 SD  for  500 coins
//     1250 SD for 1000 coins
//     3375 SD for 2500 coins
//     10150 SD for 7000 coins
//     15000 SD for 10000 coins
//
//   Draw packs (shop):
//     Single draw   = 100 coins
//     10x draw pack = 1000 coins
//
// Goals:
// - Low leagues: small but steady SD drip, no tickets.
// - Mid leagues: slightly better SD + a few seasonal tickets.
// - High leagues (Platinum+):
//     • Daily rewards include 1 free basic ticket (per day logged in).
//     • Quarterly rewards feel like a real "season reward" bump.
// - Quarterly league tickets scale from 5 (Copper) → 25 (Diamond).

export const ARENA_LEAGUES = [
    {
        id: "copper",
        name: "Copper",
        minTrophies: 0,
        dailyRewards: {
            soulDust: 3,          
            tickets: { basic: 0 },
        },
        leagueRewards: {
            soulDust: 120,        
            tickets: { basic: 5 },
        },
    },
    {
        id: "bronze",
        name: "Bronze",
        minTrophies: 100,
        dailyRewards: {
            soulDust: 4,
            tickets: { basic: 0 },
        },
        leagueRewards: {
            soulDust: 150,
            tickets: { basic: 8 },
        },
    },
    {
        id: "silver",
        name: "Silver",
        minTrophies: 300,
        dailyRewards: {
            soulDust: 5,
            tickets: { basic: 0 },
        },
        leagueRewards: {
            soulDust: 180,
            tickets: { basic: 11 },
        },
    },
    {
        id: "gold",
        name: "Gold",
        minTrophies: 600,
        dailyRewards: {
            soulDust: 7,
            tickets: { basic: 0 },
        },
        leagueRewards: {
            soulDust: 220,
            tickets: { basic: 14 },
        },
    },
    {
        id: "platinum",
        name: "Platinum",
        minTrophies: 1000,
        dailyRewards: {
            soulDust: 10,
            tickets: { basic: 1 },
        },
        leagueRewards: {
            soulDust: 400,
            tickets: { basic: 16 },
        },
    },
    {
        id: "emerald",
        name: "Emerald",
        minTrophies: 1400,
        dailyRewards: {
            soulDust: 12,
            tickets: { basic: 1 },
        },
        leagueRewards: {
            soulDust: 550,
            tickets: { basic: 18 },
        },
    },
    {
        id: "sapphire",
        name: "Sapphire",
        minTrophies: 1800,
        dailyRewards: {
            soulDust: 14,
            tickets: { basic: 1 },
        },
        leagueRewards: {
            soulDust: 750,
            tickets: { basic: 20 },
        },
    },
    {
        id: "ruby",
        name: "Ruby",
        minTrophies: 2200,
        dailyRewards: {
            soulDust: 16,
            tickets: { basic: 1 },
        },
        leagueRewards: {
            soulDust: 950,
            tickets: { basic: 22 },
        },
    },
    {
        id: "diamond",
        name: "Diamond",
        minTrophies: 2600,
        dailyRewards: {
            soulDust: 20,
            tickets: { basic: 1 }, 
        },
        leagueRewards: {
            soulDust: 1200,
            tickets: { basic: 25 }, 
        },
    },
];

export function getLeagueForTrophies(trophies) {
    const t = Math.max(0, Math.floor(trophies || 0));
    let current = ARENA_LEAGUES[0];
    for (const lg of ARENA_LEAGUES) {
        if (t >= lg.minTrophies) current = lg; else break;
    }
    return current;
}

export function getNextLeagueInfo(trophies) {
    const league = getLeagueForTrophies(trophies);
    const idx = ARENA_LEAGUES.findIndex(l => l.id === league.id);
    const next = ARENA_LEAGUES[idx + 1] || null;
    const toNext = next ? Math.max(0, next.minTrophies - (trophies || 0)) : 0;
    return { league, next, toNext };
}
